// src/features/auth/components/ResetPassword.js
import React, { useState } from 'react';
import { api } from '../../apiServices/apiClient';
import { useLocation, useNavigate } from 'react-router-dom';


function ResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError('As senhas não coincidem.');
      return;
    }
    try {
      await api.post('/reset-password', { 
        email: email, 
        password: newPassword
      });

      navigate('/login');

    } catch (err) {
      setError('Error: ');    
      
    }
  };

  return (    

    <div className="flex min-h-screen">
{/* Lado esquerdo com logo */}
<div className="w-1/2 bg-white flex items-center justify-center">
  <div className="text-center">
    <img src="public/assets/logo-mesaclick.png" alt="MesaClick Logo" className="mx-auto w-90" />
  </div>
</div>

{/* Lado direito com formulário */}
<div className="w-1/2 bg-blue-600 text-white flex items-center justify-center">
  <div className="w-full max-w-md px-8 py-12 bg-blue-700 rounded-xl shadow-lg">
    <h2 className="text-2xl font-bold mb-2 text-center">Reset de senha!!!</h2>
    <h2 className="text-1xl font-bold mb-8 text-center">Cadastre uma nova senha.</h2>
    <form onSubmit={handleSubmit}>
    <label className="block text-sm font-medium mb-1">Email: {email}</label>

      <label className="block text-sm font-medium mb-1">Nova senha:</label>
      <input
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        required
        className="w-full px-4 py-2 mb-4 rounded text-black"

      /> 

      <label className="block text-sm font-medium mb-1">Confirmar Nova senha:</label>

         <input
           type="password"
           value={confirmPassword}
           onChange={(e) => setConfirmPassword(e.target.value)}
           required
           className="w-full px-4 py-2 mb-4 rounded text-black"

         />     

      <button
        type="submit"
        className="w-full bg-white text-blue-700 font-bold py-2 px-4 rounded hover:bg-gray-100"
      >
        Redefinir Senha
      </button>
      
    </form>
    {error && <p className="error">{error}</p>}
  </div>
</div>
</div>
  );
}

export default ResetPassword;
